module.exports = __webpack_public_path__ + "img/bronze-medal.11b0bed7.png";